import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private resolve: ((value: any) => void) | undefined;
  private reject: ((reason?: any) => void) | undefined;

  constructor(private _router: Router) {}

  public data: any;

  open(modalPath: string, data: any) {
    this.data = data;
    this._router.navigate([{ outlets: { modal: modalPath } }], {
      skipLocationChange: true,
    });

    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  close(data: any) {
    if (!this.resolve) return;
    this._router.navigate([{ outlets: { modal: null } }], {
      skipLocationChange: true,
    });
    this.resolve(data);
  }

  dismiss(error = 'Modal dismissed') {
    if (!this.reject) return;
    this._router.navigate([{ outlets: { modal: null } }], {
      skipLocationChange: true,
    });
    this.reject(error);
  }
}
